function cleanOrigin(value: string | undefined): string | null {
  const origin = value?.trim().replace(/\/+$/, '');
  return origin || null;
}

const WORKER_ORIGIN = cleanOrigin(import.meta.env.VITE_WORKER_ORIGIN);
const API_ORIGIN = cleanOrigin(import.meta.env.VITE_API_ORIGIN) ?? WORKER_ORIGIN;
const WS_ORIGIN = cleanOrigin(import.meta.env.VITE_WS_ORIGIN) ?? WORKER_ORIGIN;

export const API_BASE = API_ORIGIN ? `${API_ORIGIN}/api` : '/api';

export function websocketUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (WS_ORIGIN) {
    if (WS_ORIGIN.startsWith('ws://') || WS_ORIGIN.startsWith('wss://')) {
      return `${WS_ORIGIN}${normalizedPath}`;
    }

    const origin = new URL(WS_ORIGIN);
    origin.protocol = origin.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${origin.protocol}//${origin.host}${normalizedPath}`;
  }

  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${normalizedPath}`;
}
